// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"logogrid_wrapper__28gxt","inHero":"logogrid_inHero__7Euup","item":"logogrid_item__RZ99P","viewAllLink":"logogrid_viewAllLink__A2Wz_","header":"logogrid_header__68Zfg"};